__turbopack_context__.v({
  "ul": "index-module__T9L0sW__ul",
});
